enum ErrorCodes {
  PlanningObjectOutdated = "PlanningObjectOutdated",
  Unauthorized = "errors.API.AccessDenied",
  DuplicateUserName = "errors.API.DuplicateUserName",
  NumberOfDevicesExceeded = "errors.API.NumberOfDevicesExceeded",
  NoValidLicenceForModule = "errors.API.NoValidLicenceForModule",
  noResponse = "errors.API.noResponse",
}

export default ErrorCodes
